<p-dialog
  header="Actualizar contraseña"
  [(visible)]="showDialog"
  [modal]="true"
  [closable]="false"
  [style]="{ width: '40vw' }"
  [breakpoints]="{ '1199px': '50vw', '767px': '75vw', '575px': '92vw' }"
>
  <span class="text-gray-500 block mb-5">Complete el siguiente formulario</span>
  <form [formGroup]="changePasswordForm">
    <div class="grid grid-cols-12 gap-4 w-full">
      <div class="col-span-12">
        <label for="newPassword" class="text-sm font-medium block mb-1">Nueva Contraseña <span class="text-red-500">*</span></label>
        <p-inputGroup>
          <p-inputGroupAddon>
            <i class="pi pi-lock"></i>
          </p-inputGroupAddon>
          <input id="newPassword" [type]="passwordFieldType" class="w-full" formControlName="newPassword" pInputText placeholder="Nueva Contraseña" />
          <p-inputGroupAddon (click)="togglePasswordVisibility()">
            <i [ngClass]="passwordFieldType === 'password' ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
          </p-inputGroupAddon>
        </p-inputGroup>
      </div>

      <!-- Checklist de criterios entre inputs -->
      <div class="col-span-12">
        <ul class="criteria-list">
          <li>
            <i [ngClass]="passwordCriteria.minLength ? 'pi pi-check ok' : 'pi pi-times bad'"></i>
            <span>Mínimo 12 caracteres</span>
          </li>
          <li>
            <i [ngClass]="passwordCriteria.hasUppercase ? 'pi pi-check ok' : 'pi pi-times bad'"></i>
            <span>Al menos 1 mayúscula</span>
          </li>
          <li>
            <i [ngClass]="passwordCriteria.hasNumber ? 'pi pi-check ok' : 'pi pi-times bad'"></i>
            <span>Al menos 1 número</span>
          </li>
          <li>
            <i [ngClass]="passwordCriteria.hasSpecial ? 'pi pi-check ok' : 'pi pi-times bad'"></i>
            <span>Al menos 1 carácter especial</span>
          </li>
        </ul>
      </div>

      <div class="col-span-12">
        <label for="confirmNewPassword" class="text-sm font-medium block mb-1">Confirmar Contraseña <span class="text-red-500">*</span></label>
        <p-inputGroup>
          <p-inputGroupAddon>
            <i class="pi pi-lock"></i>
          </p-inputGroupAddon>
          <input
            id="confirmNewPassword"
            [type]="passwordFieldType"
            class="w-full"
            formControlName="confirmNewPassword"
            pInputText
            placeholder="Repita la Contraseña"
          />
          <p-inputGroupAddon (click)="togglePasswordVisibility()">
            <i [ngClass]="passwordFieldType === 'password' ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
          </p-inputGroupAddon>
        </p-inputGroup>
        <small class="match-hint" [ngClass]="{ bad: changePasswordForm.errors?.['passwordMismatch'] }"> Las contraseñas deben coincidir </small>
      </div>

      <div class="col-span-12 mt-4">
        <button
          pButton
          label="Confirmar Cambios"
          icon="pi pi-check"
          iconPos="left"
          severity="success"
          class="w-full"
          [loading]="loading"
          [disabled]="changePasswordForm.status == 'INVALID' || this.loading || changePasswordForm.errors?.['passwordMismatch']"
          (click)="onSubmitNewPassword()"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>
